import { useFieldArray, useFormContext } from 'react-hook-form';

import {
  useGetProductsAcrossWarehouses,
  useGetProductsByCountry,
} from '@/modules/periodicTasks/apihooks';
import Input from '@/modules/periodicTasks/components/Create/Steps/Inputs/Input';
import { IPeriodicTasks } from '@/modules/periodicTasks/types';
import { useGetPropertyConfigurations } from '@/modules/settings/property/apiHooks';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const Inputs = () => {
  const [selectedAsset] = useStore((store) => store?.asset);

  const { control, watch } =
    useFormContext<IPeriodicTasks.IOperationFormSchema>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'products',
  });

  const operationType = watch('operationType.id');

  const { data: configurations } = useGetPropertyConfigurations(
    selectedAsset?.id
  );

  const { data: warehouseProducts, fetchNextPage: fetchWarehouseProducts } =
    useGetProductsAcrossWarehouses({
      entityId: selectedAsset?.IsInventoryActive ? selectedAsset.id : undefined,
      operationType,
      page: 1,
      limit: 100,
    });

  const { data: countryProducts, fetchNextPage: fetchCountryProducts } =
    useGetProductsByCountry({
      countryCode: !selectedAsset?.IsInventoryActive
        ? selectedAsset?.country
        : undefined,
      operationType,
      page: 1,
      limit: 100,
    });

  const products =
    warehouseProducts?.pages.flatMap((page) => page.items) ||
    countryProducts?.pages.flatMap((page) => page.items);

  const handleAppend = () => {
    append({
      rate: null,
      amount: null,
      unit: null,
      product: null,
    });
  };
  return (
    <div>
      {fields.map((field, index) => (
        <Input
          key={field.id}
          index={index}
          options={products ?? []}
          areaUnit={configurations?.areaUnit}
          measurementSystem={configurations?.measurementSystem}
          handleAppend={handleAppend}
          handleRemove={() => remove(index)}
          fetchNextPage={
            selectedAsset?.IsInventoryActive
              ? fetchWarehouseProducts
              : fetchCountryProducts
          }
        />
      ))}
    </div>
  );
};

export default Inputs;
